
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.99 1a2.24 2.24 0 100 4.48 2.24 2.24 0 000-4.48zM11.778 9.423v-.148A3.382 3.382 0 008.4 5.896h-.824a3.382 3.382 0 00-3.379 3.38v.147a.412.412 0 00.412.412h6.758a.412.412 0 00.411-.412zM7.578 11.025v2.01a1.511 1.511 0 10.824 0v-2.01h-.824zM12.8 11.765l-1.42-1.42-.589.583 1.42 1.42a1.511 1.511 0 10.584-.583h.005zM2.443 14.597a1.509 1.509 0 001.319-2.246l1.425-1.423-.588-.583-1.42 1.42a1.51 1.51 0 10-.736 2.832z","fill":"#fff"}})])
          )
        }
      }
    